<template>
  <div class="form-control-static">
    <p v-if="!_readonly">
      <el-button @click="add" class="btn" style="float: left; margin-right: 10px;">
        {{i18n.fr(spec.multi ? 'action.upload' : 'action.upload_replace')}}
      </el-button>
      <input type="file" ref="file" :multiple="spec.multi" style="display: inline-block"
             :accept="spec.accept || 'image/*'"/>
    </p>
    <p v-for="(id, i) in value_">
      <el-button v-if="!_readonly" class="btn btn-icon btn-danger"
                 @click="del(i)"><i class="ti-close"></i></el-button>
      <a :href="mediaUrl(id, 'original')" target="_blank">
        <img :src="mediaUrl(id)" style="max-height: 200px"
             :alt="filename(id)" :title="displayName(id)"/>&nbsp;
      </a>
    </p>
    <p v-if="_readonly && value_.length == 0" v-html="i18n.fr('html.empty')"></p>
  </div>
</template>

<style>
</style>

<script>
  import {map, isArray, get} from 'lodash';
  import mixin from './mixin';
  import {Button} from 'element-ui';
  import i18n from 'src/i18n/index';
  import {parseError, apiHost, formatSiUnit} from 'src/utils';
  import debug from 'src/debug';

  export default {
    components: {[Button.name]: Button},
    name: 'f-img',
    mixins: [mixin],
    data() {
      return {
        meta: {},
      };
    },
    computed: {
      value_() {
        return this.value ? [].concat(this.value) : [];
      },
      type() {
        return (this.spec && this.spec.type) || 'image';
      },
    },
    watch: {
      value_: {
        immediate: true,
        deep: true,
        handler(v) {
          for (let id of v) {
            if (!this.meta[id]) {
              this.$http
                .post('', {endpoint: 'getMediaprofileById', mediaprofile_id: id})
                .then(response => {
                  this.$set(this.meta, id, get(response.body, 'data'));
                });
            }
          }
        },
      },
    },
    methods: {
      mediaUrl(id, size = 'thumbnail') {
        return apiHost() +
          'media/' + size + '/' + encodeURIComponent(id) +
          (this.filename(id) ? '/' + encodeURIComponent(this.filename(id)) : '') +
          '?access-token=' + encodeURIComponent(this.$auth.access_token) +
          '&device-uuid=' + encodeURIComponent(this.$auth.device_uuid);
      },
      filename(id) {
        return get(this.meta[id], 'details.filename');
      },
      displayName(id) {
        let size = get(this.meta[id], 'details.size', -1);
        return (this.filename(id) || id)
          + (size >= 0 ? ' (' + formatSiUnit.byte(size) + ')' : '');
      },
      add() {
        if (!this.$refs.file.files.length) {
          return;
        }
        let p;
        if (typeof this.spec.upload === 'function') {
          p = this.spec.upload.call(this, this.$refs.file.files);
        } else {
          p = Promise.all(map(this.$refs.file.files, x => {
            return new Promise((yes, no) => {
              let r = new FileReader();
              r.addEventListener('load', () => {
                let base64 = r.result.substr(r.result.indexOf(',') + 1);
                let payload = {
                  endpoint: 'uploadPNG',
                  type: this.type,
                  sub_type: this.spec.sub_type || 'default',
                  tags: [],
                  privacy: 1,
                  details: {
                    filename: x.name,
                    mime: x.type,
                    size: x.size,
                  },
                  image: base64,
                };
                if (typeof this.spec.preprocess === 'function') {
                  payload = this.spec.preprocess.call(this, payload);
                }
                this.$http
                  .post('', payload)
                  .then(response => {
                    let mid = get(response, 'body.data.mediaprofile_id');
                    if (!mid) {
                      no(new Error('Empty response from server'));
                    } else {
                      this.$set(this.meta, mid, response.body.data);
                      yes(mid);
                    }
                  }, no);
              });
              r.readAsDataURL(x);
            });
          }));
        }

        p.then(ids => {
          ids = ids ? [].concat(ids) : [];
          if (ids.length) {
            if (this.spec.multi) {
              if (isArray(this.value)) {
                this.value = this.value.concat(ids);
              } else {
                this.value = ids;
              }
            } else {
              this.value = ids[0];
            }
          }
          this.$refs.file.value = null;
          this.$notify({
            component: {
              template: i18n.f('alert.html.file_uploaded_successfully'),
            },
            icon: 'ti-info',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'success',
          });
        }, err => {
          err = parseError(err);
          this.$notify({
            component: {
              template: i18n.f('alert.html.$err', {err}),
            },
            icon: 'ti-alert',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger',
          });
        });
      },
      del(i) {
        if (this.spec.multi) {
          if (!isArray(this.value)) {
            this.value = [];
          } else {
            this.value.splice(i, 1);
          }
        } else {
          this.value = null;
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// f-img.vue?96a157fa